import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

// Extend Window interface to include Cypress
declare global {
  interface Window {
    Cypress?: any;
  }
}

export const initialize = () => {
  // Skip Datadog initialization during Cypress tests
  if (window.Cypress || import.meta.env.CYPRESS_INSTRUMENT_PRODUCTION) {
    return;
  }

  // Initialize Datadog RUM
  datadogRum.init({
    applicationId: import.meta.env.VITE_APP_DATADOG_APP_ID ?? '',
    clientToken: import.meta.env.VITE_APP_DATADOG_CLIENT_TOKEN ?? '',
    site: 'datadoghq.eu',
    service: 'web-react-databus',
    env: import.meta.env.VITE_APP_ENVIRONMENT,
    version: '1.0.0',
    sessionSampleRate: 50,
    trackResources: true,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
  });

  // Initialize Datadog Logs
  datadogLogs.init({
    clientToken: import.meta.env.VITE_APP_DATADOG_CLIENT_TOKEN ?? '',
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sessionSampleRate: 50,
  });

  // Enable session replay
  datadogRum.startSessionReplayRecording({ force: true });
};

export const addUserAttributes = (userId: string, email: string) => {
  // Skip if Datadog was not initialized (e.g., during Cypress tests)
  if (window.Cypress || import.meta.env.CYPRESS_INSTRUMENT_PRODUCTION) {
    return;
  }
  datadogRum.setUser({ id: userId, email });
};

export const resetUserAttributes = () => {
  // Skip if Datadog was not initialized (e.g., during Cypress tests)
  if (window.Cypress || import.meta.env.CYPRESS_INSTRUMENT_PRODUCTION) {
    return;
  }
  datadogRum.clearUser();
};
